module.exports = __webpack_public_path__ + "static/media/justify.6ce23924.svg";